import { defaultItemSettings, socialLinksData } from './_itemData.js';
import { openDialog, prepareDialog } from './_dialog.js';
import { esc_url, esc_attr, esc_html, safeUrl, fetchJsonItems } from './_utils.js';

/** Render JSON profiles after the DOM is ready; options override shared image/icon defaults. */
export function loadAndRenderItemsModal(
  jsonUrl = '/assets/json/itemList.json',
  targetSelector = '.c-data-area__modal',
  options = {}
) {
  const dataAreaList = document.querySelector(targetSelector);
  if (!dataAreaList) {
    return;
  }
  const itemDetailModal = document.querySelector('dialog.c-dialog__modal__data');
  if (!itemDetailModal) {
    console.error(
      'HTMLに <dialog class="c-dialog__modal__data"> 要素が見つかりません。モーダル機能が利用できません。'
    );
    dataAreaList.innerHTML = '<p class="json-load-error">モーダル機能が利用できません。</p>';
    return;
  }
  if (typeof itemDetailModal.showModal !== 'function') {
    console.error('ブラウザがdialog要素をサポートしていません。');
    dataAreaList.innerHTML = '<p class="json-load-error">モーダル機能が利用できません。</p>';
    return;
  }
  prepareDialog(itemDetailModal);
  const settings = { ...defaultItemSettings, ...options };

  fetchJsonItems(jsonUrl)
    .then((items) => {
      const fragment = document.createDocumentFragment();

      items.forEach((itemData) => {
        const articleElement = createItemArticle(itemData, settings, itemDetailModal);
        if (articleElement) {
          fragment.appendChild(articleElement);
        }
      });
      dataAreaList.replaceChildren(fragment);
    })
    .catch((error) => {
      console.error('Error loading JSON:', error);
      dataAreaList.innerHTML =
        '<p class="json-load-error">データの読み込みに失敗しました。時間をおいてお試しください。</p>';
    });
}

function createItemArticle(itemData, settings, itemDetailModal) {
  if (!itemData || typeof itemData !== 'object' || !itemData.id || !itemData.name) {
    return null;
  }

  const article = document.createElement('article');
  article.id = `item-${itemData.id}`;
  article.className = 'c-data-area__article';
  const itemTrigger = document.createElement('div');
  itemTrigger.classList.add('item-detail-trigger');
  itemTrigger.setAttribute('role', 'button');
  itemTrigger.setAttribute('tabindex', '0');
  const figure = document.createElement('figure');
  figure.className = 'item-image';
  const image = document.createElement('img');
  image.src = safeUrl(itemData.image) || safeUrl(settings.defaultImageUrl);
  image.alt = itemData.name || 'アイテム画像';
  image.width = settings.defaultImageWidth;
  image.height = settings.defaultImageHeight;
  image.loading = 'lazy';
  figure.appendChild(image);
  itemTrigger.appendChild(figure);
  const name = document.createElement('h3');
  name.textContent = itemData.name || '';
  itemTrigger.appendChild(name);
  const nameEn = document.createElement('p');
  nameEn.textContent = itemData.nameEn || '';
  itemTrigger.appendChild(nameEn);

  article.appendChild(itemTrigger);

  itemTrigger.addEventListener('click', (event) => {
    openItemDetailModal(itemData, settings, itemDetailModal, event.currentTarget);
  });
  itemTrigger.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      openItemDetailModal(itemData, settings, itemDetailModal, event.currentTarget);
    }
  });

  return article;
}

function openItemDetailModal(itemData, settings, itemDetailModal, trigger) {
  const modalContentData = itemDetailModal.querySelector('.modal__content__data');
  if (!modalContentData) {
    console.error('モーダルコンテンツのターゲット要素 .modal__content__data が見つかりません。');
    return;
  }

  const socialLinksHtml = [];

  socialLinksData.forEach((social) => {
    if (safeUrl(itemData[social.name])) {
      socialLinksHtml.push(`
                <li>
                    <a href="${esc_url(
                      itemData[social.name]
                    )}" target="_blank" rel="noopener noreferrer">
                        <img src="${esc_url(
                          `${settings.socialIconBasePath}${social.icon}`
                        )}" alt="${esc_attr(social.label || social.name)}へのリンク" width="24" height="24">
                    </a>
                </li>
            `);
    }
  });

  const modalHtml = `
      <h2 class="modal-item-name">${esc_html(itemData.name || '')}</h2>
      <p class="modal-item-name-en">${esc_html(itemData.nameEn || '')}</p>
      <div class="modal-image-wrapper">
          <figure><img src="${esc_url(safeUrl(itemData.image) || settings.defaultImageUrl)}" alt="${
            itemData.name ? esc_attr(itemData.name) + 'の画像' : esc_attr('アイテム画像')
          }" loading="lazy"></figure>
      </div>
      <p class="modal-birthDay">誕生日: ${esc_html(itemData.birthDay || '')}</p>
      <ul class="modal-social-links">
          ${socialLinksHtml.join('')}
      </ul>
      ${
        safeUrl(itemData.url)
          ? `<p class="modal-url"><a href="${esc_url(
              itemData.url
            )}" target="_blank" rel="noopener noreferrer">公式サイト</a></p>`
          : ''
      }
      <p class="modal-message">${esc_html(itemData.message || '')}</p>
  `;
  modalContentData.innerHTML = modalHtml;
  openDialog(itemDetailModal, trigger);
}
